export default __webpack_public_path__ + "static/media/errorThree.66610698.gif";